module.exports = __webpack_public_path__ + "static/media/logo.e42fc50f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 25
// module chunks = 0